import { Controller } from "stimulus"
export default class extends Controller {
  static get targets() {
    return [];
  }
  connect(){

  }

  check(e){
    let val = e.target.value; 
    let data = JSON.parse(e.target.getAttribute('data-backordered-opt')) 
    let wrapper = this.existingWrapper(e.target); 
    if (wrapper) {
      wrapper.querySelector('.backorder-popup').style.display = 'none';
    }
    if (data[val] === 1) {
      let target = e.target; 
      if (wrapper) {
        wrapper.querySelector('.backorder-popup').style.display = 'block';
      }
      else { 
      wrapper = document.createElement('div');wrapper.classList.add('backorder-popup-wrapper');
      target.parentNode.insertBefore(wrapper, target);
      wrapper.appendChild(target);
      wrapper.insertAdjacentHTML('beforeend', this.popup())
      }
    }
  }

  existingWrapper(elem){
    return elem.parentNode.classList.contains('backorder-popup-wrapper')  ? elem.parentNode : null; 
  }

  popup() {
    return `
     <div style='display: block' class='backorder-popup popover right'> 
       <div class='arrow '> </div>
       <p>This Option has Backordered Parts </p>
     </div>
    `
  }

}

  
